import { useEffect, useState } from 'react'
import styles from './Limits.module.scss'
import toastService from '../../services/toastService'
import settingsService from '../../services/settingsService'

const Limits = () => {
  const [commission, setCommission] = useState('')
  const [currentCommission, setCurrentCommission] = useState(null)

  useEffect(() => {
    settingsService
      .getCommission()
      .then((response) => setCurrentCommission(response?.commission ?? null))
      .catch(() => {})
  }, [])

  const handleCommission = (event) => {
    setCommission(event.target.value)
  }

  const handleNumber = (e) => {
    const inputValue = e.target.value
    e.target.value = inputValue.replace(/[^\d.]/g, '')
  }

  const onClickCommission = () => {
    const value = Number(commission)
    if (commission === '' || isNaN(value) || value < 0 || value > 100) {
      toastService.show('error', 'Agent commission must be a percentage between 0 and 100')
      return
    }
    settingsService
      .addCommission({ commission: value })
      .then(() => {
        setCurrentCommission(value)
        setCommission('')
        toastService.show('success', `Agent commission set to ${value}%`)
      })
      .catch((error) => {
        toastService.show('error', 'Error add agent commission' + error?.message || '')
      })
  }

  return (
    <div className={styles.wrapper}>
      <p className='mt-4 mb-1'>Agent commission (% of customer payments):</p>
      <p className='small mb-2'>
        Current: <strong>{currentCommission !== null ? `${currentCommission}%` : '—'}</strong>.
        Applies to agents registered after the change; an individual agent’s rate is set on the
        Agents page.
      </p>
      <div className={styles.agentLimit}>
        <div className='input-group me-2'>
          <input
            style={{ background: '#121621' }}
            className='form-control bordered'
            type='text'
            inputMode='decimal'
            placeholder='e.g. 10'
            value={commission}
            onInput={handleNumber}
            onChange={handleCommission}
          />
          <span className='input-group-text'>%</span>
        </div>
        <button onClick={onClickCommission} className='btn btn-lightblue'>
          Save
        </button>
      </div>
    </div>
  )
}

export default Limits
